module.exports = __webpack_public_path__ + "static/img/Bachelor_010814.1f00823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010814.jpg
// module id = 256
// module chunks = 0